import { Component, Input, OnInit, ChangeDetectorRef, OnDestroy, WritableSignal, signal   } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { RoleServicesService } from 'src/app/services/role-services.service';
import { SettingsService } from 'src/app/services/settings.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { manageCandidatesSlugs, manageEventsSlugs, manageJobRoelsSlugs, PermissionGroups, SubPermissionGroup, SubPermissionGroupPermission } from '../primary-account/primary-account.component';
import { markAllControlsAsPristine } from 'src/app/shared/form.utils';

@Component({
    selector: 'app-role-and-permission',
    templateUrl: './role-and-permission.component.html',
    styleUrls: ['./role-and-permission.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RoleAndPermissionComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  activeTab: string = 'users';
  role_and_permission_list: any[] = [];
  module_slug_list: any = [];
  _module_slug_list: any = [];
  moduleList: any = [];
  isLoading: boolean = false;
  clicked: boolean = false;
  addRoleAndPermissionSidebar: boolean = false;
  saveBtnLoading: boolean = false;
  edit: boolean = false;
  saveDisable: boolean = false;
  roleData : any;
  assignedPermissionIds: Set<number> = new Set();
  userPrivileges: Set<string> = new Set();
  
  @Input() forceRolesTab: boolean = false;
  @Input() addRole$: Subject<void> = new Subject<void>();
  openedRole: WritableSignal<any> = signal<any>(null);
  permissionGroups: PermissionGroups[] = [
    { label: "Manage Events", icon: "pi pi-calendar", slugs: manageEventsSlugs, active: true, subgroups: [] },
    { label: "Manage Candidates", icon: "pi pi-users", slugs: manageCandidatesSlugs, active: false, subgroups: [] },
    { label: "Manage Job Roles", icon: "pi pi-clone", slugs: manageJobRoelsSlugs, active: false, subgroups: [] },
    { label: "Settings", icon: "pi pi-cog", slugs: [], active: false, subgroups: [] },
  ]

  roleAndPermissionForm: FormGroup;
  constructor(private settingService: SettingsService,private roleService: RoleServicesService, private messageService: MessageService, private confirmationService: ConfirmationService,private globalService: GlobalServicesService, private cdRef: ChangeDetectorRef,private sharedService: SharedServicesService) {
    this.roleAndPermissionForm = new FormGroup({
      role_name: new FormControl('', [Validators.required]),
      module: new FormControl(''),
      role_description: new FormControl('', [Validators.required]),
      permissions: new FormControl([])
    });
   }
  ngOnInit() {
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });

    if(this.forceRolesTab) {
      this.switchTab("roles")
      this.addRole$.pipe(takeUntil(this.unsub$)).subscribe(() => {
        this.edit = false;
        this.openSideBar()
      })
    } 
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }

  switchTab(tab: string) {
    this.activeTab = tab;
    this.cdRef.detectChanges();
  
    if (tab === 'roles') {
      if (this.role_and_permission_list.length === 0) {
        this.getRoleAndPermission();
        this.roleAndPermissionFormData();
      }
    }
  }
  
  roleAndPermissionFormData(){
    this.isLoading = true;
    this.roleService.getRoleAndPermissionFormDataFastApi().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.module_slug_list = res.body.map((group: any) => ({
            label: group.group, 
            slug: group.group.toLowerCase().replace(/\s+/g, '_'), 
            permissions: group.permissions.map((perm: any) => ({
                id: perm.id,
                name: perm.display_name,
                slug: perm.slug_name,
                isChecked: false,
                isDisabled: false
            })),
            isSelectedAll: false
        }));
        this.moduleList = this.module_slug_list.map((module: any) => ({
            label: module.label, 
            value: module.slug
        }));
    },
    error: (error: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({ severity: 'error', summary: 'Error', detail: error.message });
    }
    });
  }
  getRoleAndPermission() {
    this.isLoading = true;
    this.roleService.getRoleAndPermissionFastApi().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.role_and_permission_list = res.body.map((role: any) => ({
          ...role,
          permissions: role.permissions ?? []
        })).sort((a: any, b: any) => a.id - b.id);

        if (this.role_and_permission_list?.length) {
          this.setOpenedRole(this.role_and_permission_list[0])
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({
          severity: 'error',
          summary: 'Error',
          detail: error.message
        });
      }
    });
  }
openSideBar(edit = false) {
  this.roleData = [];
  this.clicked = false;
  this.edit = edit;
  this.assignedPermissionIds.clear();
  this.roleAndPermissionForm.reset();
  this.roleAndPermissionForm.patchValue({ module: '' });
  this._module_slug_list = this.module_slug_list.map((module: any) => ({
    ...module,
    permissions: module.permissions.map((permission: any) => ({
      ...permission,
      isChecked: false
    })),
    isSelectedAll: false,
    isExpanded: false
  }));

  this.addRoleAndPermissionSidebar = true;
  this.cdRef.detectChanges();
  this.initializePermissionGroups()
}
  cancelRoleAndPermission(){
    this.addRoleAndPermissionSidebar = false;
  }
  getAllPermissions() {
    if (!this._module_slug_list || this._module_slug_list.length === 0) {
      return [];
  }

  const selectedPermissions = this._module_slug_list.reduce((acc: number[], module: any) => {
      if (module.permissions) {
          module.permissions.forEach((permission: any) => {
              if (permission.isChecked) {
                  acc.push(Number(permission.id)); 
              }
          });
      }
      return acc;
  }, []);
  return selectedPermissions;
}

saveRoleAndPermission() {
  this.clicked = true;

  // Mark controls as touched to show errors
  this.roleAndPermissionForm.get('role_name')?.markAsTouched();
  this.roleAndPermissionForm.get('role_description')?.markAsTouched();

  // Security check using shared service - check role name and description fields
  const fieldsToCheck = ['role_name', 'role_description'];
  if (this.sharedService.hasSecurityViolations(this.roleAndPermissionForm, fieldsToCheck)) {
    this.globalService.commonGrowl.next({ 
      severity: 'error', 
      summary: 'Security Error', 
      detail: 'Please fix the security violations shown in the form before saving.' 
    });
    return;
  }

  if (this.roleAndPermissionForm.invalid) {
    return;
  }

  const allPermissions = this.getAllPermissions();

  if (allPermissions.length === 0) {
    this.globalService.commonGrowl.next({
      severity: 'error',
      summary: 'Error',
      detail: 'Please select at least one permission before saving.',
    });
    return;
  }

  // Get secure payload using shared service
  let secureFormValue = this.sharedService.getSecurePayload(this.roleAndPermissionForm.value);
  
  const createRoleAndPermissionPayload = {
    name: secureFormValue.role_name, // Use sanitized value
    description: secureFormValue.role_description, // Use sanitized value
    permissions: allPermissions,
  };
  
  this.roleService.createRoleAndPermissionFastApi(createRoleAndPermissionPayload).subscribe({
    next: (response) => {
      if (response.status === 201) {
        this.roleAndPermissionForm.reset();
        this.roleData = [];
        this.getRoleAndPermission();
        this.clicked = false;
        this.addRoleAndPermissionSidebar = false;
        this.globalService.commonGrowl.next({
          severity: 'success',
          summary: 'Success',
          detail: 'Role created successfully!',
        });
      }
      this.saveBtnLoading = false;
    },
    error: (_err) => {
      this.saveBtnLoading = false;
      this.roleData = [];
    }
  });
}
  syncPermissionsWithUpdatedRole() {
      if (!this.roleData || !this.roleData.permissions) {
          console.warn("⚠ No updated role data available.");
          return;
      }
      this.assignedPermissionIds = new Set(this.roleData.permissions.map((perm: any) => perm.id));
      this._module_slug_list = this._module_slug_list.map((module: any) => {
          const updatedPermissions = module.permissions.map((permission: any) => ({
              ...permission,
              isChecked: this.assignedPermissionIds.has(permission.id)
          }));
          return {
              ...module,
              permissions: updatedPermissions,
              isSelectedAll: updatedPermissions.every((permission: any) => permission.isChecked)
          };
    });
    this.cdRef.detectChanges();
  }
  updateRoleAndPermission() {
    this.saveBtnLoading = true;
    if(!this.roleAndPermissionForm.dirty) {
      this.globalService.commonGrowl.next({ 
        severity: 'warn', 
        summary: 'No Changes Detected', 
        detail: 'You haven\'t made any changes to the form. Please update at least one field before submitting.' 
      });
      this.saveBtnLoading = false;
      return;
    }

    this.clicked = true;
    this.roleAndPermissionForm.get('role_name')?.markAsTouched();
    this.roleAndPermissionForm.get('role_description')?.markAsTouched();
    const fieldsToCheck = ['role_name', 'role_description'];
    if (this.sharedService.hasSecurityViolations(this.roleAndPermissionForm, fieldsToCheck)) {
      this.globalService.commonGrowl.next({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.saveBtnLoading = false;
      return;
    }
    if (this.roleAndPermissionForm.invalid) {
      this.saveBtnLoading = false;
      return;
    }
    const allPermissions = this.getAllPermissions();
    if (allPermissions.length === 0) {
      this.globalService.commonGrowl.next({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select at least one permission before updating.',
      });
      this.saveBtnLoading = false;
      return;
    }
    let secureFormValue = this.sharedService.getSecurePayload(this.roleAndPermissionForm.value);
    const updatePayload = {
      name: secureFormValue.role_name,
      description: secureFormValue.role_description,
      permissions: [...allPermissions],
    };
    this.roleService.updateRoleAndPermissionFastApi(this.roleData.id, updatePayload).subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.roleData = {
            ...this.roleData,
            name: updatePayload.name,
            description: updatePayload.description,
            permissions: updatePayload.permissions.map((id) => ({ id })),
          };

          this.assignedPermissionIds = new Set(updatePayload.permissions);
          this._module_slug_list = this.module_slug_list.map((module: any) => ({
            ...module,
            permissions: module.permissions.map((permission: any) => ({
              ...permission,
              isChecked: this.assignedPermissionIds.has(permission.id),
            })),
            isSelectedAll: module.permissions.every((permission: any) =>
              this.assignedPermissionIds.has(permission.id)
            ),
          }));
          this.initializePermissionGroups();

          this.cdRef.detectChanges();

          this.clicked = false;
          this.addRoleAndPermissionSidebar = false;
          this.globalService.commonGrowl.next({
            severity: 'success',
            summary: 'Success',
            detail: 'Role updated successfully!',
          });
        }
        this.saveBtnLoading = false;
        markAllControlsAsPristine(this.roleAndPermissionForm)
      },
      error: () => {
        this.saveBtnLoading = false;
      },
    });
  }
  deleteRoleAndPermission(role: any) {
    this.isLoading = true;
    this.roleService.deleteRoleAndPermissionFastApi(role.id).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({
          severity: 'success',
          summary: 'Success',
          detail: 'Role deleted successfully!'
        });
        this.getRoleAndPermission();
      },
      error: (error: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({
          severity: 'error',
          summary: 'Error',
          detail: error.message || 'An error occurred while deleting the role.'
        });
      }
    });
  }  
  editOption(role: any) {
    this.addRoleAndPermissionSidebar = true;
    this.clicked = false;
    this.edit = true;
    this.isLoading = true;
    this.roleService.getSpecificRoleAndPermissionFastApi(role.id).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.roleData = res.body ?? {};
        const rolePermissions = this.roleData.permissions || [];
        this.roleAndPermissionForm.patchValue({
          role_name: this.roleData.name ?? '',
          role_description: this.roleData.description ?? '',
          module: ''
        });
  
        this.assignedPermissionIds = new Set(rolePermissions.map((perm: any) => Number(perm.id)));
  
        this._module_slug_list = this.module_slug_list.map((module: any) => ({
          ...module,
          permissions: module.permissions.map((permission: any) => ({
            ...permission,
            isChecked: this.assignedPermissionIds.has(permission.id) 
          })),
          isSelectedAll: module.permissions.every((permission: any) =>
            this.assignedPermissionIds.has(permission.id)
          )
        }));
  
        this.cdRef.detectChanges();
        this.initializePermissionGroups()
      },
      error: (error: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({ severity: 'error', summary: 'Error', detail: error.message });
      }
    });
  }
  updateSelectedCheckboxes(module: any, selected_all?: boolean) {
    if (!module.permissions) {
        return;
    }

    if (selected_all) {
      module.permissions.forEach((permission: any) => {
          permission.isChecked = module.isSelectedAll;
      });
    } else {
      module.isSelectedAll = module.permissions.every((permission: any) => permission.isChecked);
  }
  this.cdRef.detectChanges();
}

togglePermission(module: any, permission: any) {
  if (!module.permissions) {
      return;
  }
  permission.isChecked = !permission.isChecked;
  module.isSelectedAll = module.permissions.every((perm: any) => perm.isChecked);
  this.cdRef.detectChanges();
}
getModuleSlugList() {
    const selectedModuleSlug = this.roleAndPermissionForm.value.module;
    const selectedModule = this.module_slug_list.find(
        (module: any) => module.slug === selectedModuleSlug
    );

    if (!selectedModule) {
        console.warn("Warning: Selected module not found.");
        return;
    }
    const existingModule = this._module_slug_list.find((module: any) => module.slug === selectedModuleSlug);
    if (existingModule) {
        return;
    }

    const newModule = {
        ...selectedModule,
        permissions: selectedModule.permissions.map((permission: any) => ({
            ...permission,
            isChecked: this.assignedPermissionIds.has(permission.id)
        })),
        isSelectedAll: selectedModule.permissions.every((permission: any) => this.assignedPermissionIds.has(permission.id))
    };

    this._module_slug_list.push(newModule);
    this.cdRef.detectChanges();
  }
  toggleExpand(slug: any) {
    slug.isExpanded = !slug.isExpanded;
}

  setOpenedRole(role: any, override: boolean = false) {
    if(this.addRoleAndPermissionSidebar && override) {
      this.openSideBar(true)
      return;
    }
  
    if(!role) {
      return;
    }

    this.openedRole.set(role);
    this.openSideBar(true)
    setTimeout(() => {
      this.editOption(this.openedRole());
      this.edit = true;
    }, 100);
  }

  togglePermissionNew(permission: SubPermissionGroupPermission) {
    permission.isChecked = !permission.isChecked;

    const activeSubPermissionGroup = this.getActiveSubPermissionGroup();
    if (activeSubPermissionGroup) {
      activeSubPermissionGroup.isSelectedAll = activeSubPermissionGroup.permissions.every((perm: any) => perm.isChecked);
    }

    this.roleAndPermissionForm.markAsDirty();
  }

  initializePermissionGroups() {
    this.permissionGroups = [
      { label: "Manage Events", icon: "pi pi-calendar", slugs: manageEventsSlugs, active: true, subgroups: [] },
      { label: "Manage Candidates", icon: "pi pi-users", slugs: manageCandidatesSlugs, active: false, subgroups: [] },
      { label: "Manage Job Roles", icon: "pi pi-clone", slugs: manageJobRoelsSlugs, active: false, subgroups: [] },
      { label: "Settings", icon: "pi pi-cog", slugs: [], active: false, subgroups: [] },
    ];

    (this._module_slug_list as any[]).forEach((module_slug) => {
      const slug = module_slug.slug;
      const matchingGroup = this.permissionGroups.find(group => group.slugs.includes(slug));

      const subPermissionGroup: SubPermissionGroup = {
        ...module_slug,
        active: false
      }

      if (matchingGroup) {
        matchingGroup.subgroups.push(subPermissionGroup);
      } else {
        const fallbackGroup = this.permissionGroups.find(group => group.slugs.length === 0);
        if (fallbackGroup) {
          fallbackGroup.subgroups.push(subPermissionGroup);
        } else {
          console.warn(`No fallback group found for slug "${slug}"`);
        }
      }
    })
    this.permissionGroups.forEach((group, index) => {
      group.active = false;
      if (index === 0) group.active = true;

      if (group.active) {
        group.subgroups.forEach((subgroup, index) => {
          subgroup.active = false;
          if (index === 0) subgroup.active = true;
        })
      }
    })
  }

  changeActivePermissionGroup(group: PermissionGroups) {
    this.permissionGroups.forEach((permissionGroup) => {
      permissionGroup.active = false;

      if(permissionGroup.label === group.label) {
        permissionGroup.active = true;
      }

      permissionGroup.subgroups.forEach((subPermission, index) => {
        subPermission.active = false;
        if(permissionGroup.active && index === 0) {
          subPermission.active = true;
        }
      })
    })
  }

  getActivePermissionGroup() {
    return this.permissionGroups.find((permissionGroup) => permissionGroup.active);
  }

  getActiveSubPermissionGroup() {
    return this.getActivePermissionGroup()?.subgroups?.find((subgroup) => subgroup.active)
  }

  changeActiveSubPermissionGroup(subGroup: SubPermissionGroup) {
    const activePermissionGroup = this.permissionGroups.find((permissionGroup) => permissionGroup.active);
    if (activePermissionGroup) {
      activePermissionGroup.subgroups.forEach((subPerGroup) => {
        subPerGroup.active = false;
        if (subPerGroup.slug === subGroup.slug) {
          subPerGroup.active = true;
        }
      })
    }
  }

  getActivePermissionsSubGroups(fromAdd: boolean = false) {
    const activePermissionGroup = this.permissionGroups.find((permission) => permission.active);
    if(activePermissionGroup) {
      return activePermissionGroup.subgroups;
    }

    return []
  }

  getActiveSubPermissionsValues() {
    const activePermissionsSubGroup = this.getActivePermissionsSubGroups();
    const activeSubPermission = activePermissionsSubGroup.find((subPermission) => subPermission.active);
    if(activeSubPermission) {
      return activeSubPermission.permissions;
    }

    return [];
  }
}
